import { z } from 'zod';

const decimalString = z
  .union([z.string(), z.number()])
  .transform((value) => String(value))
  .refine((value) => /^-?\d+(\.\d+)?$/.test(value), 'invalidDecimal');

export const MatchedBookEntrySchema = z.object({
  counterparty_id: z.string(),
  currency: z.string(),
  gross_repo_notional: decimalString,
  gross_reverse_repo_notional: decimalString,
  net_funding_position: decimalString,
  expected_net_interest_pnl: decimalString,
  has_residual: z.boolean(),
  residual_notional: decimalString,
  deal_count: z.number().int(),
  updated_at: z.string(),
});

export type MatchedBookEntry = z.infer<typeof MatchedBookEntrySchema>;

export const MatchedBookListSchema = z.array(MatchedBookEntrySchema);

export const MatchedBookFiltersSchema = z.object({
  currency: z.string().trim().optional(),
});

export type MatchedBookFilters = z.infer<typeof MatchedBookFiltersSchema>;

export const MatchedBookPayloadSchema = z.object({
  filters: MatchedBookFiltersSchema.optional(),
});

export type MatchedBookPayload = z.infer<typeof MatchedBookPayloadSchema>;
